import(/* webpackMode: "eager" */ "/app/apps/portal/src/app/monitoring/error.tsx");
